import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();

    if (loading || user === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-slate-50">
                <div className="text-slate-500 text-sm animate-pulse">
                    Loading workspace...
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Only apply role-based redirect when roles were actually provided.
    if (
        roles &&
        user.role === "super_admin" &&
        !roles.includes("super_admin")
    ) {
        return <Navigate to="/platform" replace />;
    }

    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}